import React from 'react';
import { GenerarFacturasPanel } from '../components/GenerarFacturasPanel';

export const GenerarFacturasPage: React.FC = () => {
  return <GenerarFacturasPanel />;
};
